import { useState } from "react";
import { Box, Collapse, Alert, IconButton, Typography } from "@mui/material";
import { ReactComponent as ErrorCircleSvg } from "../../loginImages/error-circle.svg";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from "@mui/material/styles";
import PrimaryButton from "../StyledButtons/PrimaryButton";
import { myVJBlue200, myVJBlue300 } from "../../constants/brandingColors";

const size = 24;

const BtnContainer = styled("div")({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexDirection: "column",
});

interface ErrorAlertProps {
  title: string;
  subTitle: string;
  buttonText: string;
  onClick: (state) => void;
}

const ErrorAlert = ({
  title,
  subTitle,
  buttonText,
  onClick,
}: ErrorAlertProps) => {

  const [open, setOpen] = useState(true);

  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          icon={false}
          tabIndex={0}
          sx={(theme) => ({
            mb: 2,
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.main,
            borderRadius: '8px',
            p: 2,
            position: 'relative',
          })}
        >
          <Box sx={(theme) => ({
            display: 'flex',
            paddingTop: theme.spacing(1),
            alignItems: 'flex-start', // Top align all elements
            gap: 1,
            mb: 1,
            justifyContent: 'space-between',
          })}>
            <Box sx={{
              display: 'flex',
              alignItems: 'flex-start', // Top align icon and text
              gap: 1,
              flex: 1,
            }}>
              <Box
                sx={{
                  position: 'relative',
                  width: size,
                  height: size,
                  flexShrink: 0,
                  mt: 0.125, // Small margin to align with text baseline
                }}
              >
                <ErrorCircleSvg width={size} height={size} />
              </Box>
              <Typography
                component="h4"
                variant="h4"
                fontWeight="600"
                sx={(theme) => ({
                  color: theme.palette.error.main,
                  lineHeight: 1.2,
                })}
              >
                {title}
              </Typography>
            </Box>

            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={(theme) => ({
                color: theme.palette.error.main,
                padding: theme.spacing(0.5),
                mt: -0.75, // Move slightly higher for better alignment
              })}
              size="small"
            >
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Box>

          <Typography
            variant="subtitle1"
            fontWeight="400"
            sx={(theme) => ({
              color: theme.palette.error.main,
              mb: 2,
              width: '100%', // Ensure full width
              paddingRight: 0, // Allow text to flow under close button
            })}
          >
            {subTitle}
          </Typography>

          <BtnContainer>
            <PrimaryButton
              id="login-password-btn"
              text={buttonText}
              dataTestId="password-btn"
              onClick={onClick}
              color={myVJBlue200}
              hoverColor={myVJBlue300}
              fullWidth={false}
            />
          </BtnContainer>
        </Alert>
      </Collapse>
    </Box>
  );
};

export default ErrorAlert;